// pages/devolucionesCompra/DevolucionesCompra.tsx
import PageLayout from "../../components/layout/PageLayout";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import { DevolucionCompraList } from "../../components/DevolucionCompra/DevolucionCompraList";

const DevolucionesCompra = () => {
  return (
    <PageLayout 
      icon={AssignmentReturnIcon} 
      title="Devoluciones de Compra"
    >
      <DevolucionCompraList />
    </PageLayout>
  );
};

export default DevolucionesCompra;